// doc - https://bootstrap-vue.js.org/docs/components/table/

const tableConfig = {
  props: {
    caption: {
      type: String,
      default: 'Table'
    },
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: true
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    },
    responsive: {
      type: String,
      default: 'sm'
    },
    stacked: {
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: true
    },
    headVariant: {
      type: String,
      // default: 'light' // o padrão é o light porém fica acizentado
      default: ''
    },
    footVariant: {
      type: String,
      // default: 'light' // o padrão é o light porém fica acizentado
      default: ''
    },
    footClone: {
      type: Boolean,
      default: false
    }
  }
}

export default tableConfig
